module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/Card/images/sample-emblem.0d5bb16e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/images/sample-emblem.png
// module id = 3128
// module chunks = 11